import React from "react";
import { Camera } from "lucide-react";
import { API_ORIGIN } from "../../axios";

// Round avatar with a camera badge; clicking it opens the file picker.
const AvatarPicker = ({ imgchange, havepic, picture, showpicture, onPick }) => (
  <label className="relative cursor-pointer group shrink-0">
    <input style={{ display: "none" }} type="file" accept="image/*" onChange={onPick} />
    {!imgchange ? (
      havepic ? (
        <img
          className="w-24 h-24 rounded-full object-cover border-4 border-white shadow-lg"
          alt="linkakam"
          src={`${API_ORIGIN}/profile/` + picture}
        />
      ) : (
        <img
          className="w-24 h-24 rounded-full object-cover border-4 border-white shadow-lg"
          alt="linkakam"
          src={`${process.env.PUBLIC_URL}/images/pp.png`}
        />
      )
    ) : (
      <img
        className="w-24 h-24 rounded-full object-cover border-4 border-white shadow-lg"
        alt="linkakam"
        src={showpicture}
      />
    )}
    <span className="absolute bottom-0 right-0 w-8 h-8 rounded-full bg-indigo-600 text-white flex items-center justify-center shadow-md ring-2 ring-white group-hover:bg-indigo-700 transition">
      <Camera className="w-4 h-4" />
    </span>
  </label>
);

export default AvatarPicker;
